<div class="main-container">
    <div class="invoice-form-payment-order-form-container">
        <div [formGroup]="invoiceForm" *ngIf="invoiceForm">
            <table class="invoice-form-container">
                <tr>
                    <td>
                        <p>
                            *Invoice number
                        </p>
                    </td>
                    <td>
                        <p>
                            *Amount
                        </p>
                    </td>
                    <td>
                        <p>
                            *Date of invoice
                        </p>
                    </td>
                    <td>
                        <p>
                            Currency
                        </p>
                    </td>
                    <td>
                        <p>
                            Means of Payment
                        </p>
                    </td>
                    <td>
                        <p>
                            *Due date
                        </p>
                    </td>
                    <td>
                        <p>
                            Comment
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <input pInputText formControlName="invoiceNumber">
                    </td>
                    <td>
                        <input pInputText formControlName="amount" (change)="amountChange($event)">
                        <p class="global-warning"
                            *ngIf="invoiceForm.get('amount')!.errors && invoiceForm.get('amount')!.errors!['invalidCharacters']">
                            Wrong format</p>
                    </td>
                    <td>
                        <p-calendar formControlName="date" dateFormat="dd/mm/yy"></p-calendar>
                    </td>
                    <td>
                        <p-dropdown [options]="currencyService.currencies" optionLabel="isoCode"
                            formControlName="currency" [style]="{'min-width':'70px'}">
                        </p-dropdown>
                    </td>
                    <td>
                        <p-dropdown [options]="bookingService.paymentTypes" optionLabel="name"
                            formControlName="paymentType">
                        </p-dropdown>
                    </td>
                    <td>
                        <p-calendar dateFormat="dd/mm/yy" formControlName="dueDate"></p-calendar>
                        <p class="global-warning"
                            *ngIf="submitFail && invoiceForm.errors&&invoiceForm!.errors!['dueDateNotPresent']">
                            *required</p>
                    </td>
                    <td>
                        <input pInputText formControlName="comment">
                    </td>
                </tr>
            </table>
            <div class="file-uploader">
                <p-fileUpload #fileUploader mode="basic" [auto]="false" (onSelect)="onFileSelect($event.currentFiles)"
                    [maxFileSize]="16000000" chooseIcon="pi pi-none" chooseLabel="Upload file">
                </p-fileUpload>
                <p-button (onClick)="clearSelectedFile()" label="Clear" chooseLabel="File upload"></p-button>
            </div>

            <div class="invoice-condition-container">
                <table>
                    <tr>
                        <td>
                            <p>
                                This invoice will be paid by multiple times
                            </p>
                        </td>
                        <td class="checkbox-container">
                            <p-checkbox formControlName="multiplePayments" [binary]="true"></p-checkbox>
                        </td>
                    </tr>
                    <tr *ngIf="isSchoolInvoiceValidator">
                        <td>
                            <span>
                                This is a valid invoice
                            </span>
                        </td>
                        <td class="checkbox-container">
                            <p-checkbox formControlName="isValid" [binary]="true"></p-checkbox>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <div *ngIf="invoiceForm && invoiceForm.get('multiplePayments')!.value">
            <div class="payment-order-form-head">
                <div>
                    <p>
                        #
                    </p>
                </div>
                <div>
                    <p>
                        *Amount
                    </p>
                </div>
                <div>
                    <p>
                        *Due Date
                    </p>
                </div>
            </div>
            <div *ngFor="let paymentOrder of paymentOrderForms; let i = index;" [formGroup]="paymentOrder"
                class="payment-order-container">
                <div>
                    <p>
                        Payment {{i+1}}
                    </p>
                </div>
                <div>
                    <input pInputText formControlName="amount" (change)="amountChange($event)">
                    <p class="global-warning"
                        *ngIf="paymentOrder.get('amount')!.errors && paymentOrder.get('amount')!.errors!['invalidCharacters']">
                        Wrong format</p>
                </div>
                <div>
                    <p-calendar dateFormat="dd/mm/yy" formControlName="dueDate"></p-calendar>
                    <p class="global-warning" *ngIf="submitFail && paymentOrder.get('dueDate')!.invalid">*required</p>
                </div>
                <div>
                    <p-button icon="pi pi-trash" (onClick)="deletePaymentOrderForm(i)"
                        styleClass="p-button-danger"></p-button>
                </div>
            </div>
            <div>
                <p *ngIf="invalidAmount" class="global-warning">
                    Sum of payments must be equal to invoice amount
                </p>
            </div>
            <div class="add-button-container">
                <p-button label="Add" (onClick)="addPaymentOrder(1)"></p-button>
            </div>
        </div>
    </div>
    <div class="submit-button-container">
        <p-button label="Submit" (onClick)="submit()"></p-button>
    </div>
</div>